import { useNavigate } from "react-router-dom";
import { Plane, Factory, Building2, Leaf } from "lucide-react";

const DEFAULT = [
  { id: "aerotropolis", label: "Vaal Aerotropolis", sub: "(Aviation & Logistics)", icon: Plane, x: 40, y: 16 },
  { id: "sez", label: "Proposed Vaal SEZ", sub: "(Industrial & Manufacturing)", icon: Factory, x: 47, y: 30 },
  { id: "vrc", label: "Vaal River City", sub: "(Residential & Mixed Use)", icon: Building2, x: 38, y: 48 },
  { id: "agri_cluster", label: "Agri-Processing Cluster", sub: "(Food & Agro-Industry)", icon: Leaf, x: 50, y: 66 },
];

export const HeroCallouts = ({ items = DEFAULT, className = "" }) => {
  const nav = useNavigate();
  return (
    <div className={`pointer-events-none absolute inset-0 hidden lg:block ${className}`}>
      {items.map((c) => (
        <button
          key={c.id}
          data-testid={`hero-callout-${c.id}`}
          onClick={() => nav(`/explore?initiative=${c.id}`)}
          className="pointer-events-auto absolute flex flex-col items-center"
          style={{ left: `${c.x}%`, top: `${c.y}%` }}
        >
          <span className="vig-glass flex items-center gap-2.5 px-3 py-1.5 text-left transition-transform hover:scale-105">
            <c.icon className="h-5 w-5 text-white" strokeWidth={1.6} />
            <span>
              <span className="block text-[13px] font-semibold leading-tight text-white">{c.label}</span>
              <span className="block text-[11px] text-slate-300">{c.sub}</span>
            </span>
          </span>
          <span className="h-10 w-px bg-white/70" />
          <span className="h-2 w-2 rounded-full bg-white shadow-[0_0_0_4px_rgba(255,255,255,.2)]" />
        </button>
      ))}
      <span className="absolute right-6 top-[84px] rounded bg-black/40 px-2 py-0.5 text-[10px] uppercase tracking-wider text-slate-300">Concept visual — illustrative, not an approved design</span>
    </div>
  );
};

export const PageHero = ({ code, title, subtitle, body, image = "/media/hero.jpg", children, actions, callouts = true, minH = "min-h-[430px]" }) => (
  <section className={`relative overflow-hidden ${minH}`}>
    <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />
    <div className="hero-shade absolute inset-0" />
    <div className="hero-shade-top absolute inset-0" />
    {callouts && <HeroCallouts />}
    <div className="relative z-10 mx-auto max-w-[1600px] px-5 pb-8 pt-28 lg:px-8">
      <div className="flex flex-col gap-8 xl:flex-row xl:items-start">
        <div className="max-w-[640px] flex-1">
          <div className="vig-eyebrow rise" data-testid="page-code">{code}</div>
          <h1 className="rise d1 mt-2 text-4xl font-bold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-[54px]" data-testid="page-title">{title}</h1>
          {subtitle && <p className="rise d2 mt-3 text-lg leading-snug text-slate-100 md:text-[21px]">{subtitle}</p>}
          {body && <p className="rise d3 mt-4 max-w-[560px] text-[14.5px] leading-relaxed text-slate-300">{body}</p>}
          {actions && <div className="rise d4 mt-6 flex flex-wrap gap-3">{actions}</div>}
        </div>
        {children}
      </div>
    </div>
  </section>
);
